import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Question from "../../components/Question";
import MoveButton from "../../components/MoveButton";
import { Stack, Box, useTheme, useMediaQuery } from "@mui/material";
import { setPickedMedication as updatePickedMedication } from '../../redux/userSlice';
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function PickedMedication() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const user = useSelector((state) => state.user);

    const { portal = false } = location.state || {};

    const options = user.isIsotretinoin
    ? {
        "Yes": "yes",
        "No": "no",
      }
    : {
        "Yes": "yes",
        "No": "no",
        "I wasn't prescribed anything": "I wasn't prescribed anything",
      };

    const questionTitle = user.isIsotretinoin
        ? "You were prescribed Isotretinoin (Accutane), were you able to pick it up?"
        : "If you were prescribed any medication, were you able to pick it up?";

    const handleClick = (option) => {
        dispatch(updatePickedMedication(options[option]));
        if (options[option] === "yes") {
            setPageAndDeferNavigate(dispatch, '/currently-prescribed', () =>
                navigate('/currently-prescribed', { state: { portal } })
            );
        } else {
            if (user.sex.sexAtBirth === "Female" || user.sex.sexAtBirth === "Prefer not to answer") {
                setPageAndDeferNavigate(dispatch, '/maternity', () =>
                    navigate('/maternity', { state: { returning: true, portal } })
                );
            } else {
                setPageAndDeferNavigate(dispatch, '/recent-photo', () =>
                    navigate('/recent-photo', { state: { returning: true, portal } })
                );
            }
        }
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/feeling-now', () =>
            navigate('/feeling-now', { state: { portal } })
        );
    };

    return (
        <Question
            onBack={handleBack}
            returning={true}
            title={questionTitle}
            subtitle="Select One"
            input={
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                >
                    <Stack
                        spacing={2}
                        width="100%"
                        maxWidth={isDesktop ? "400px" : "100%"}
                        alignItems="center"
                    >
                        {Object.keys(options).map((option) => (
                            <MoveButton
                                key={option}
                                sx={{
                                    width: '100%',
                                    maxWidth: '400px',
                                }}
                                onClick={() => handleClick(option)}
                                title={option}
                                selected={user.pickedMedication === options[option]}
                            />
                        ))}
                    </Stack>
                </Box>
            }
        />
    );
}